import {CsvReadItem} from '../../../../../src/AppState/PromotionQuestionsState/PromotionQuestionsState';
import {SelectOptionsType} from '../../../../../src/components/CustomersBar/CustomerTab/MarketingTab/Select/Select';
import {SelectState} from '../../../../../src/components/CustomersBar/CustomerTab/MarketingTab/Select/Select.state';

export type QuestionAnswers = Record<string, string>

export class SelectStateAndQuestion {
    readonly question: CsvReadItem;
    readonly state: SelectState;
    readonly currentAnswer: string | undefined;

    constructor(question: CsvReadItem, state: SelectState, currentAnswer: string | undefined) {
        this.question = question;
        this.state = state;
        this.currentAnswer = currentAnswer;
    }

    get questionId(): string {
        return this.question.id;
    }

    get answerValue(): string | null {
        return this.state.currentValue ?? null;
    }

    get isActive(): boolean {
        return this.question.active;
    }

    get selectOptions(): SelectOptionsType {
        const result: SelectOptionsType = {};
        this.question.possibleAnswers?.forEach((answer) => {
            result[answer] = answer;
        });
        return result;
    }
}

const generateSelects = (questions: CsvReadItem[], answers: QuestionAnswers): SelectStateAndQuestion[] => {
    const selects: SelectStateAndQuestion[] = [];
    questions.forEach((question) => {
        if (!question.active) {
            return;
        }
        //@ts-expect-error
        const currentAnswer: string = answers[question.id];
        const selectState = new SelectState(currentAnswer);
        selects.push(new SelectStateAndQuestion(question, selectState, currentAnswer));
    });
    return selects;
};

export class MarketingQuestionsState {

    private readonly questions: CsvReadItem[];
    private readonly answers: QuestionAnswers;
    selects: SelectStateAndQuestion[] = [];

    constructor(questions: CsvReadItem[], answers: QuestionAnswers) {
        this.questions = questions;
        this.answers = answers;
        this.selects = generateSelects(this.questions, this.answers);
    }

    getSelectsValues = (): QuestionAnswers => {
        const out: QuestionAnswers = {};
        for (const item of this.selects) {
            const answer = item.answerValue;
            if (answer !== null) {
                out[item.questionId] = answer;
            }
        }
        return out;
    }

    getFinalAnswers = () => {
        const result = this.getSelectsValues();
        if (Object.keys(result).length > 0) {
            const formAnswers: QuestionAnswers = {};
            this.questions.forEach(question => {
                const selectedAnswer = result[question.id];
                if (selectedAnswer) {
                    formAnswers[question.id] = selectedAnswer;
                }
            });
            const finalAnswers: QuestionAnswers = {...this.answers, ...formAnswers}; // always override
            return finalAnswers;
        }
        return {...this.answers};
    }
}
